import { Ref, computed, onBeforeMount, reactive, ref } from "vue";

type TNotificationLogin = {
  disable: boolean;
  message: string;
  severity: string;
};

type TNotificationsList = {
  login: TNotificationLogin;
};
/**
 * Type-safe composable for Vue components
 * Composable created as a reference for future composables
 * @param notificationName notification key [login|more-to-come]
 * @returns notification:typeof notificationList[notificationName] read-only;
 * disableNavigation(read-only);
 */
export default function useNotification<
  NotificationName extends keyof TNotificationsList,
>(notificationName: NotificationName) {
  const notificationList: TNotificationsList = reactive({ login: null });

  const disableNavigation = computed(
    () =>
      notificationList.login &&
      notificationList.login.disable &&
      import.meta.env.VITE_IGNORE_NOTIFICATION_DISABLE !== "true",
  );

  onBeforeMount(async () => {
    try {
      Object.assign(
        notificationList,
        await (
          await fetch("https://static.bithotel.io/notifications.json")
        ).json(),
      );
    } catch (e) {
      /* empty */
    }
  });
  return {
    notification: computed(() => notificationList[notificationName]),
    disableNavigation,
  };
}
